import { 
    CreateActivityTypeDto, 
    DeleteActivityTypeDto,
    EditActivityTypeDto,
    GetActivityTypeDto, 
    MessageResponseDto, 
    UtilActivityTypeControllerGet200Response,
    UtilityActivityTypeApiFp,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseUtilActivityTypeModel = UtilActivityTypeControllerGet200Response;
export type GetUtilActivityTypeModel = GetActivityTypeDto;
export type MutateResponseUtilActivityTypeModel = MessageResponseDto;
export type CreateUtilActivityTypeModel = CreateActivityTypeDto;
export type UpdateUtilActivityTypeModel = EditActivityTypeDto;
export type DeleteUtilActivityTypeModel = DeleteActivityTypeDto;

export const apiUtilActivityTypeFp =  UtilityActivityTypeApiFp(apiConfig);
export const getUtilActivityTypeController = apiUtilActivityTypeFp.utilActivityTypeControllerGet;
export const createUtilActivityTypeController = apiUtilActivityTypeFp.utilActivityTypeControllerCreate;
export const updateUtilActivityTypeController = apiUtilActivityTypeFp.utilActivityTypeControllerEdit;
export const deleteUtilActivityTypeController = apiUtilActivityTypeFp.utilActivityTypeControllerDelete;

export const QueryKeyUtilActivityType = QueryKey.UtilActivityType;